(function ($) {

    /** Logo slider */
    $('.logo-slider').slick({
        arrows: false,
        dots: false,
        swipeToSlide: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });

    /** Table wrap */
    document.querySelectorAll('table').forEach(function(table) {
        // Create a new <div> element with the class "table-wrap"
        var wrapper = document.createElement('div');
        wrapper.className = 'table-wrap overflow-auto';

        // Insert the wrapper before the table in the DOM
        table.parentNode.insertBefore(wrapper, table);

        // Move the table inside the wrapper
        wrapper.appendChild(table);
    });

    /** AOS animation */
    AOS.init({once: true});

    /** Header Fixed */
    $(window).scroll(function (e) {
        if ($(this).scrollTop() > 0) {
            $('body').addClass('header-fixed');
        } else {
            $('body').removeClass('header-fixed');
        }
    });

    /** Enable tooltip */
    // const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    // const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    /** Scroll To Top */
    $('#scroll-to-top').on('click', function () {
        $(window).scrollTop(0);
    });
    $(window).scroll(function () {
        let scroll = $(window).scrollTop();
        if (scroll >= 600) {
            $("#scroll-to-top").addClass("active");
        } else {
            $("#scroll-to-top").removeClass("active");
        }
    });

    /** Responsive menu button */
    $('.responsive__menu_button').on('click', function () {
        $('body').toggleClass('responsive__menu_active');
    });

    $(document).on('click', 'body.responsive__menu_active .responsive__menu_overlay', function () {
        $('body').removeClass('responsive__menu_active');
    });

})
(jQuery);